<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><a id="ch00_fm06_pre1"></a><a id="page_vi"></a><img alt="image" src="images/f00vi-01.jpg"/></p>
<p class="figcap">Photo courtesy of the <span class="small">LBJ</span> School of Public Affairs, University of Texas at Austin.</p>
<p class="noindent"><a id="page_vii"></a><em>Liberty lies in the hearts of men and women; when it dies there, no constitution, no law, no court can save it; no constitution, no law, no court can even do much to help it. While it lies there it needs no constitution, no law, no court to save it ….</em></p>
<p class="indent"><em>The spirit of liberty is the spirit which is not too sure that it is right; the spirit of liberty is the spirit which seeks to understand the minds of other men and women; the spirit of liberty is the spirit which weighs their interests alongside its own without bias; the spirit of liberty remembers that not even a sparrow falls to earth unheeded; the spirit of liberty is the spirit of Him who, near two thousand years ago, taught mankind that lesson it has never learned, but has never quite forgotten; that there may be a kingdom where the least shall be heard and considered side by side with the greatest ….</em></p>
<p class="attribution">—<span class="small">JUDGE LEARNED HAND, MAY 21</span>, 1944<a id="page_viii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm06_pre1.vue?e165cb82